module.exports = __webpack_public_path__ + "img/coupons_v2.c585486.png";